import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addColor = async (token, data) => {
  const url = `${BASE_URL}/products/product-color/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const getAllColors = async (token, params = {}) => {
  const url = `${BASE_URL}/products/product-color/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getColor = async (token, colorId) => {
  const url = `${BASE_URL}/products/product-color/${colorId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateColor = async (token, data, colorId) => {
  const url = `${BASE_URL}/products/product-color/${colorId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteColor = async (token, colorId) => {
  const url = `${BASE_URL}/products/product-color/${colorId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
